import type { ReceiptBatchFormValues } from '../components/receipt-batch/interfaces/ReceiptBatchFormValues';
import type {
  ReceiptBatch,
  UpdateReceiptBatch,
} from '@pflegenavi/service-provider-frontend/api';

export function transformReceiptBatchFormValuesToUpdateReceiptBatchPhoenix(
  values: ReceiptBatchFormValues
): UpdateReceiptBatch {
  if (!values.nursingHomeId) {
    throw new Error('Nursing home ID is required');
  }
  return {
    receipt_date: values.receiptDate,
    nursing_home_id: values.nursingHomeId,
    generate_receipts: values.generateReceipts,
    use_individual_dates: values.individualDatesMode,
    receipt_image_ids: values.batchImageIds,
    receipt_batch_entries: values.receipts.map((receipt) => ({
      receipt_images:
        receipt.receiptImageIds?.map((imageId) => ({
          id: imageId,
          auto_generated: false,
        })) ?? [],
      resident_id: receipt.residentId,
      receipt_date: receipt.individualDate,
      line_items: receipt.lineItems.map((lineItem) => ({
        amount_per_item: lineItem.amount ?? 0,
        name: lineItem.name ?? '--',
        taxes: lineItem.taxes?.map((tax) => ({
          display_explanation: tax.displayExplanation,
          explanation_short: tax.explanationShort,
          explanation_long: tax.explanationLong,
          tax_amount: tax.taxAmount,
          tax_name: tax.taxName,
          country_id: tax.countryId,
          paragraph: tax.paragraph,
          tax_abbreviation: tax.taxAbbreviation,
        })),
      })),
    })),
  };
}

export function transformReceiptBatchPhoenixToReceiptBatchValues(
  values: ReceiptBatch
): ReceiptBatchFormValues {
  return {
    receiptDate: values.receipt_date,
    nursingHomeId: values.nursing_home.id,
    generateReceipts: values.generate_receipts,
    individualDatesMode: values.use_individual_dates,
    receipts: values.receipt_batch_entries.map((entry) => ({
      id: entry.id,
      receiptImageIds: entry.receipt_images.map((image) => image.id),
      residentId: entry.resident.id,
      lineItems: entry.line_items.map((lineItem) => ({
        id: lineItem.id,
        count: 1,
        _internalId: lineItem.id,
        amount: lineItem.amount_per_item,
        name: lineItem.name,
        taxes: lineItem.taxes.map((tax) => ({
          displayExplanation: tax.display_explanation,
          explanationShort: tax.explanation_short,
          explanationLong: tax.explanation_long,
          taxName: tax.tax_name,
          countryId: tax.country_id,
          taxAmount: parseFloat(tax.tax_amount),
          taxAmountInPercentage: parseFloat(tax.tax_amount) * 100,
          paragraph: tax.paragraph,
          taxAbbreviation: tax.tax_abbreviation,
        })),
      })),
    })),
  };
}
